<template>
  <div class="guide-wrapper w-100">
    <!-- 列表内容 -->
    <div class="com-list-content" style="margin-top: 0;padding-top:0">
      <div class="button">
        <el-row>
          <el-button class="el-primary-border" round @click="handleAdd('add')">
            <svg-icon icon-class="add" />&nbsp;添加视频
          </el-button>
        </el-row>
      </div>
      <!-- 表格 -->
      <div class="table mt-20">
        <el-table ref="multipleTable" v-loading="listLoading" stripe :data="tableData">
          <el-table-column  label="序号" width="50">
            <template slot-scope="scope">{{ scope.$index+1 }}</template>
          </el-table-column>
          <el-table-column  prop="name" label="视频名称" show-overflow-tooltip>
          </el-table-column>

          <!-- 操作 -->
          <el-table-column  fixed="right" label="操作" min-width="20%">
            <template slot-scope="scope">
              <a class="m-btn mr-10" @click="handleEdit(scope.row)">详情</a>
              <a class="m-btn mr-10 m-danger" @click="handleDelete(scope.row)">删除</a>
            </template>
          </el-table-column>
        </el-table>

        <div class="pagination-container paging">
          <el-pagination :current-page="listQuery.currentPage" :page-size="listQuery.size" :total="total" background layout="total, prev, pager, next, sizes, jumper" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
        </div>
      </div>
    </div>

    <div>
      <el-dialog title="查看视频" @close="onCancel1" :visible.sync="dialogVisible1" :width="'600px'">
        <el-form ref="form" :model="addForm">
          <el-form-item class="mb-30" prop="name">
            <el-input v-model="addForm.name" disabled />
          </el-form-item>

          <el-form-item class="mb-30" prop="type">
            <el-select v-model="addForm.type" disabled>
              <el-option v-for="item in videoTypeList" :key="item.dictCode" :label="item.dictName" :value="item.dictCode">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item class="mb-30">
            <el-input v-model="videoUrl" disabled />
          </el-form-item>

          <el-form-item class="avatar-uploader-form">

            <video v-if="videoUrl != ''" v-bind:src="videoUrl" class="w-100" controls="controls">
              您的浏览器不支持视频播放
            </video>

            <img v-if="imgUrl" style="height:150px;object-fit:cover;" :src="imgUrl" class="avatar">
          </el-form-item>
        </el-form>
      </el-dialog>
    </div>

    <!-- 新增 -->
    <div>
      <el-dialog title="添加视频" @close="onCancel" :visible.sync="dialogVisible" :width="'750px'">
        <!-- 列表头部 -->
        <div class="com-list-header" style="padding:0;padding-bottom: 20px">
          <el-form class="com-search-box" :model="form" ref="form" label-width="80px">
            <el-row :gutter="20">
              <el-col :span="8">
                <el-form-item>
                  <el-input v-model="form.title" placeholder="请输入关键字"></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="8">
                <el-form-item>
                  <el-select v-model="form.type" placeholder="请选择类型">
                    <el-option v-for="item in videoTypeList" :key="item.dictCode" :label="item.dictName" :value="item.dictCode">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>

              <el-col :span="8">
                <div>
                  <el-button type="primary" @click="getTableList">查询</el-button>
                  <el-button @click="resetForm">重置</el-button>
                </div>
              </el-col>
            </el-row>
          </el-form>

        </div>

        <!-- 列表内容 -->
        <div class="com-list-content" style="margin-top: 0;padding-top:0">
          <div class="button">
            <el-row>
              <el-button class="el-primary-border" round @click="saveVideo()">
                <svg-icon icon-class="add" />&nbsp;添加到相关视频
              </el-button>
            </el-row>
          </div>
          <!-- 表格 -->
          <div class="table mt-20">
            <el-table ref="multipleTable" v-loading="listLoading1" stripe :data="tableData1" @selection-change="handleSelectionChange">
              <el-table-column type="selection" width="55">
              </el-table-column>
              <el-table-column  label="序号" width="50">
                <template slot-scope="scope">{{ scope.$index+1 }}</template>
              </el-table-column>
              <el-table-column  prop="name" label="视频名称" show-overflow-tooltip></el-table-column>
              <el-table-column  prop="type" label="类别" show-overflow-tooltip>
                <template slot-scope="scope">{{ handleTypeId(scope.row.type) }}</template>
              </el-table-column>
            </el-table>

            <div class="pagination-container paging">
              <el-pagination :current-page="listQuery1.currentPage" :page-size="listQuery1.size" :total="total1" background layout="total, prev, pager, next, sizes, jumper" @size-change="handleSizeChange1" @current-change="handleCurrentChange1" />
            </div>
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>

export default {
  components: {
  },
  props: ['exhibitionId'],
  data() {
    return {
      form: { title: '', type: '' },
      addForm: {},
      videoUrl: '',
      imgUrl: '',
      videoTypeList: [],
      listLoading: false,
      listLoading1: false,
      listQuery: { currentPage: 1, size: 10 },
      listQuery1: { currentPage: 1, size: 10 },
      total: 0,
      total1: 0,
      tableData: [],
      tableData1: [],
      multipleSelection: [],
      dialogVisible: false,
      dialogVisible1: false
    }
  },
  watch: {
    exhibitionId(newV) {
      this.getData()
      this.getDicData()
    }
  },
  methods: {
    // 项目列表
    getData() {
      this.listLoading = true
      this.$api.applet.getExhibitionSPList({
        id: this.exhibitionId,
        ...this.listQuery
      }).then(res => {
        this.listLoading = false
        if (res.success) {
          if (res.result && res.result.records) {
            this.tableData = res.result.records
            this.total = res.result.total
          }
        } else {
          this.$message.error(res.message)
        }
      })
    },

    getDicData() {
      this.$http
        .get('/collectDict/getSelectDataByKey', { key: 'video_type' })
        .then(res => {
          if (res.success) {
            var result = res.result
            this.videoTypeList = result
          } else {
            this.$message.error(res.message)
          }
        })
    },


    handleTypeId(typeId) {
      let arr = this.videoTypeList.filter(item => {
        return item.dictCode == typeId
      })
      if (arr && arr.length > 0) {
        return arr[0].dictName
      }

      return null
    },

    handleDelete(obj) {
      this.$common.confirm(
        {
          title: `是否确认删除？`,
          className: 'cus-confirm-375'
        }, () => {
          this.$api.applet.exhibitionRelationdelete({ id: obj.id, relationId: obj.relationId }).then(res => {
            if (res.success) {
              this.$message.success('删除成功')
              this.getData()
            } else {
              this.$message.error(res.message)
            }
          })
        }
      )
    },

    handleEdit(obj) {
      this.addForm = obj
      this.dialogVisible1 = true
      if (obj.pic) {
        this.imgUrl = `/singleMuseum/attach/getFile?fileId=${obj.pic}`
      }

      if (obj.url) {
        this.videoUrl = `/singleMuseum/attach/getFile?fileId=${obj.url}`
      }
    },

    onCancel1() {
      this.addForm = {}
      this.dialogVisible1 = false
      this.imgUrl = ''
      this.videoUrl = ''


    },

    onCancel() {
      this.dialogVisible = false
      this.multipleSelection = []
      this.form = {
        title: '',
        type: ''
      }
    },

    handleSelectionChange(list) {
      let ids = []
      if (list && list.length > 0) {
        list.map(item => {
          ids.push(item.id)
        })
      }
      this.multipleSelection = ids;
    },

    // 关联展品
    saveVideo() {
      const self = this
      if (this.multipleSelection.length <= 0) {
        this.$message.warning('请选择关联视频')
        return
      }
      this.$api.applet.getExhibitionSPSave({
        id: this.exhibitionId,
        ids: this.multipleSelection.join(',')
      }).then(res => {
        if (res.success) {
          this.$message.success({
            message: "视频关联成功",
            onClose() {
              self.dialogVisible = false
              self.getData()
            }
          })
        } else {
          this.$message.error(res.message)
        }
      })
    },

    // 重置查询
    resetForm() {
      this.form = {
        title: '',
        type: ''
      }
      this.listQuery1.currentPage = 1
      this.getVideoList()
    },

    // 查询
    getTableList() {
      this.listQuery1.currentPage = 1
      this.getVideoList()
    },

    // 新增
    handleAdd() {
      this.dialogVisible = true
      this.getVideoList()
    },

    getVideoList() {
      this.listLoading1 = true
      this.tableData = []
      this.$api.applet.getAudioVideoList({
        ...this.form,
        ...this.listQuery1
      }).then(res => {
        this.listLoading1 = false
        if (res.success) {
          if (res.result && res.result.records) {
            this.tableData1 = res.result.records
            this.total1 = res.result.total
          }
        } else {
          this.$message.error(res.message)
        }
      })
    },

    // 表格分页
    handleSizeChange(val) {
      this.listQuery.size = val
      this.getData()
    },
    // 点击序号
    handleCurrentChange(val) {
      this.listQuery.currentPage = val
      this.getData()
    },

    // 表格分页
    handleSizeChange1(val) {
      this.listQuery1.size = val
      this.getVideoList()
    },
    // 点击序号
    handleCurrentChange1(val) {
      this.listQuery1.currentPage = val
      this.getVideoList()
    },


  },
  created() {
    // this.getData()
  }
}
</script>

<style lang="scss" scoped>
.guide-wrapper {
  /deep/ .el-form-item {
    .el-form-item__content {
      margin-left: 0 !important;
      .el-select {
        width: 100%;
      }
    }

    &.avatar-uploader-form {
      display: flex;
      flex-direction: column;
      /deep/ .el-form-item__content {
        margin-left: 0 !important;
      }

      .avatar-uploader {
        width: 50%;
        border: 1px dashed #8c939d;
        height: 120px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .el-icon-plus {
          font-size: 20px;
        }

        .el-upload__text {
          line-height: 1;
        }
      }
    }
  }
}
</style>